import * as OvationsApi from 'core/ovations-api';
import { dateTimeCurrent } from 'core/util/datetime';
import { mockCallDisposition } from './callDisposition';
import { mockCallType } from './callType';
import { mockClaimDetails as claim } from './claimDetail';
import mockCustomer from './customer';
import { mockPromotionSummary } from './promotion';

export const mockPlatformUser: OvationsApi.Types.PlatformUserProfile = {
    id: 'test-user',
    firstName: 'Test',
    lastName: 'Person',
    email: 'test@person.com',
    userName: 'testperson',
    isArchived: false,
    platformPermissions: [],
    clientRoles: [],
    createDate: '',
};

export const mockCallState: OvationsApi.Types.CallState = {
    id: 0,
    clientId: 'test-client',
    programId: 'test-program',
    platformUser: mockPlatformUser,
    customer: mockCustomer,
    callType: mockCallType,
    callDisposition: mockCallDisposition,
    promotion: mockPromotionSummary,
    claim: claim[0],
    startTime: dateTimeCurrent(),
    endTime: dateTimeCurrent(),
    notes: 'test notes',
    isCall: false,
};

export const mockCustomerUpdate: OvationsApi.Types.CustomerHistory = {
    date: dateTimeCurrent(),
    changedBy: 'Test Person',
    isNotification: false,
    historyNotification: null,
    details: [
        {
            propertyName: 'Status',
            oldValue: 'Non-Certified',
            newValue: 'Certified',
            oldFileName: null,
            newFileName: null,
            oldValueUrl: null,
            newValueUrl: null,
            reason: null,
        },
        {
            propertyName: 'Address',
            oldValue: 'Old Address 111 St',
            newValue: 'New Address 222 St',
            oldFileName: null,
            newFileName: null,
            oldValueUrl: null,
            newValueUrl: null,
            reason: null,
        },
        {
            propertyName: 'Zip',
            oldValue: '11111',
            newValue: '22222',
            oldFileName: null,
            newFileName: null,
            oldValueUrl: null,
            newValueUrl: null,
            reason: null,
        },
    ],
};
